import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';

export const TotalIncomePanel = styled.div`
  padding: 15px;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 4px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  .row:last-child {
    margin-bottom: 0;
  }
`;

export const CoApplicantHint = styled.div`
  font-size: 12px;
  line-height: 13px;
  font-style: italic;
  margin-top: 12px;
`;

export const MonthlyIncomeTitleContainer = styled.div`
  position: relative;
  margin-bottom: 22px;
`;

export const MonthlyIncomeTitle = styled.div`
  font-size: 15px;
  color: ${COLORS.GREY_3};
`;

export const MonthlyIncomeSubLabel = styled.div`
  position: absolute;
  top: 1.75em;
  color: ${COLORS.GREY_3};
  font-size: ${({ theme: { fontSize } }) => fontSize.mini};
`;
